export default {
	login: "Iniciar sesión",
	email: "Correo electrónico",
	password: "Contraseña",
	username: "Nombre de usuario",
	forgotPassword: "Olvidé mi contraseña",
	resetPassword: "Restablecer contraseña",
	welcomeBack: "Bienvenido de nuevo",
	loginSubtitle: "Inicia sesión en tu cuenta para continuar",
	createAccount: "Crear nueva cuenta",
	registerSubtitle: "Únete al sistema ORI",
	createAccountButton: "Crear cuenta",
	noAccount: "¿No tienes cuenta? Regístrate",
	hasAccount: "¿Ya tienes cuenta? Inicia sesión",
	haveInviteCode: "¿Tienes un código de invitación? Actívalo aquí",
	systemDescription: "Gestiona tu templo con respeto a las tradiciones y tecnología moderna",
	welcomeToOri: "Bienvenido al ORI",
	registerDescription: "Comienza tu jornada en la gestión espiritual con el mejor sistema para templos",
	features: {
		people: "Gestión de Personas",
		peopleDesc: "Registro, asistencia y seguimiento",
		journey: "Jornada Espiritual",
		journeyDesc: "Guías, orixás y etapas de desarrollo",
		rituals: "Rituales y Sesiones",
		ritualsDesc: "Agenda, tipos y control de asistencia",
		financial: "Control Financiero",
		financialDesc: "Fondos, suscripciones, pagos e informes",
		communication: "Comunicación",
		communicationDesc: "Mensajes, TV y soporte",
		reports: "Panel e Informes",
		reportsDesc: "Dashboard y visión general",
	},
	backToLogin: "Volver al inicio de sesión",
	checkYourEmail: "Revise su bandeja de entrada y siga las instrucciones para restablecer su contraseña.",
	confirmPassword: "Confirmar Contraseña",
	emailSent: "¡Correo enviado!",
	forgotPasswordSubtitle: "Introduzca su correo electrónico para recibir un enlace de recuperación",
	invalidToken: "Enlace inválido",
	invalidTokenMessage: "Este enlace ha caducado o es inválido. Solicite un nuevo enlace de recuperación.",
	inviteCode: "Código de Invitación",
	newPassword: "Nueva Contraseña",
	passwordChanged: "¡Contraseña cambiada!",
	passwordChangedMessage: "Su contraseña ha sido cambiada con éxito. Inicie sesión para continuar.",
	passwordsDoNotMatch: "Las contraseñas no coinciden",
	requestNewLink: "Solicitar nuevo enlace",
	resetError: "Error al restablecer contraseña. Inténtelo de nuevo.",
	resetPasswordSubtitle: "Introduzca su nueva contraseña",
	sendResetLink: "Enviar enlace de recuperación",
	messages: {
		registerSuccess: "¡Usuario registrado con éxito! Redirigiendo al inicio de sesión...",
		loginError: "Error al iniciar sesión",
		registerError: "Error al registrar usuario",
	},
};
